import { PersonalInfoEditForm } from "./PersonalInfoEditForm";

export default PersonalInfoEditForm;
